import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { LAB_STATUS_TRACKER } from "./apiRoutes";

interface LabStatusTrackerItem {
  status: string;
  count: number;
}

interface LabStatusTrackerResponse {
  status: number;
  error: boolean;
  count: number;
  data: {
    items: LabStatusTrackerItem[];
  };
  message: string;
}

interface LabStatusTrackerParams {
  fromTargetDate?: string;
  endTargetDate?: string;
  region?: string;
}

const fetchLabStatusTracker = async (params?: LabStatusTrackerParams) => {
  // If no params provided, call the endpoint without query params to fetch unfiltered results
  if (!params || Object.keys(params).length === 0) {
    const response = await axiosAuth.get<LabStatusTrackerResponse>(LAB_STATUS_TRACKER);
    return response.data;
  }

  const response = await axiosAuth.get<LabStatusTrackerResponse>(LAB_STATUS_TRACKER, { params });
  return response.data;
};

export const useGetLabStatusTrackerQuery = (
  params?: LabStatusTrackerParams,
  options?: Omit<UseQueryOptions<
    LabStatusTrackerResponse,
    Error,
    LabStatusTrackerResponse,
    ["labStatusTracker", LabStatusTrackerParams | undefined]
  >, 'queryKey' | 'queryFn'>
) =>
  useQuery<
    LabStatusTrackerResponse,
    Error,
    LabStatusTrackerResponse,
    ["labStatusTracker", LabStatusTrackerParams | undefined]
  >({
    queryKey: ["labStatusTracker", params], // This will change when params change, triggering refetch
    queryFn: ({ queryKey }) => {
      const [, queryParams] = queryKey;
      return fetchLabStatusTracker(queryParams);
    },
    ...options,
  });